import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_BOLETINES = 'ALL_BOLETINES';
export const LOADING_ALL_BOLETINES = 'LOADING_ALL_BOLETINES';
export const ACTIVO_BOLETINES = 'ACTIVO_BOLETINES';
export const PARAMS_BOLETINES = 'PARAMS_BOLETINES';
export const BOLETIN_BOLETINES = 'BOLETIN_BOLETINES';
export const ASISTENCIAS_BOLETINES = 'ASISTENCIAS_BOLETINES';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  message: null,
  params: {
    idSeccion: null,
  },
  boletin: null,
  asistencias: null,
};

export const boletinesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_BOLETINES:
      return {
        ...state,
        all: action.payload,
      };
    case ACTIVO_BOLETINES:
      return {
        ...state,
        activo: action.payload,
      };
    case BOLETIN_BOLETINES:
      return {
        ...state,
        boletin: action.payload,
      };
    case ASISTENCIAS_BOLETINES:
      return {
        ...state,
        asistencias: action.payload,
      };
    case LOADING_ALL_BOLETINES:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_BOLETINES:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
